import React from "react";
import { useNavigate } from "react-router-dom";

export default function VerifyEmailSuccess() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        maxWidth: 520,
        margin: "80px auto",
        padding: "24px",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        textAlign: "center",
        fontFamily:
          "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
      }}
    >
      <h1 style={{ marginBottom: 8 }}>Email verified</h1>
      <p style={{ color: "#475569", lineHeight: 1.6 }}>
        Your email has been successfully verified. You can now sign in to your
        account.
      </p>
      <div style={{ marginTop: 24 }}>
        <button
          onClick={() => navigate("/login")}
          style={{
            background: "#2563eb",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: 8,
            border: 0,
            cursor: "pointer",
          }}
        >
          Continue to login
        </button>
      </div>
    </div>
  );
}
